import React, { Fragment } from 'react';

export function Address(props)
{
    if (!props.address) {
        return null;
    }
    return (
        <div>
            {props.address.line1}<br/>
            {props.address.line2 && <Fragment>{props.address.line2}<br/></Fragment>}
            {props.address.city && <Fragment>{props.address.city},</Fragment>} {props.address.state} {props.address.zip}
        </div>
    );
}